import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

// project-imports
import useAuth from "hooks/useAuth"

// types
import { allowedRoles, GuardProps, UserRoles } from "types/auth"

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, user } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(`/`, {
        state: {
          from: location.pathname
        },
        replace: true
      })
    } else {
      if (!allowedRoles(user || undefined)) {
        navigate("/", {
          state: {
            from: ""
          },
          replace: true
        })
      }
    }
  }, [isLoggedIn, navigate, location])

  return children
}

export default AuthGuard
